import { Component } from 'react';
import { Link } from 'react-router-dom';
import withRouter from 'utils/with-router';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import * as _ from 'lodash';
import { fromNow } from 'utils/date';
import types from 'utils/prop-types';
import constants from 'utils/constants';
import { fetchNotifications, setNotificationAsRead, setAllNotificationsAsRead } from 'ducks/modules/notifications';
import { fetchInbox } from 'ducks/modules/messages';

import Icon from 'components/icon/icon';
import LightLoader from 'components/light-loader/light-loader';
import DisplayPicture from 'components/display-picture/display-picture';
import 'components/notifications-menu/notifications-menu.scss';
import { Tooltip } from 'react-tooltip';
import { getWorkUrl } from '../../utils/works';

class NotificationsMenu extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loadingNotifications: false,
        };
        this.bottomTrigger = true;
        // throttled handler to fetch more work activity items when scrolled to bottom
        this.throttledLoadMoreNotifications = _.throttle(() => this.loadMoreNotifications(), 3000, { trailing: false });
    }

    componentDidMount() {
        if (this.props.location.pathname !== '/inbox') {
            this.props.fetchInbox();
        }
    }

    componentDidUpdate(prevProps) {
        if (
            prevProps.notifications &&
            this.props.notifications &&
            prevProps.notifications.items.length !== this.props.notifications.items.length &&
            this.props.inbox &&
            this.props.inbox.length > 0 &&
            this.props.notifications.items.find(
                (n) =>
                    n.notification_type === 'LICENSE_REQUEST' &&
                    n.licenseMeta.message_id &&
                    Number(n.licenseMeta.message_id) > 0 &&
                    !this.props.inbox.find((request) => Number(request.id) === Number(n.licenseMeta.message_id)),
            )
        ) {
            this.props.fetchInbox();
        }
    }

    async loadMoreNotifications() {
        if (!this.state.loadingNotifications) {
            this.setState({ loadingNotifications: true });
            await this.props.fetchNotifications();

            this.setState({
                loadingNotifications: false,
            });
        }
    }

    readNotification(e, notificationId, stopPropagation) {
        if (stopPropagation) {
            e.preventDefault();
            e.stopPropagation();
        } else {
            this.props.closeMenu();
        }
        this.props.setNotificationAsRead(notificationId);
    }
    readAllNotifications(e) {
        e.preventDefault();
        this.props.setAllNotificationsAsRead();
    }

    convertAlpha2Num(code) {
        return Object.keys(constants.CountryISOAlpha2Codes).find(
            (key) => constants.CountryISOAlpha2Codes[key] === code,
        );
    }

    getLicenceDetails(id) {
        const message =
            this.props.inbox && this.props.inbox.length > 0
                ? this.props.inbox.find((request) => Number(request.id) === Number(id)) || {}
                : {};

        const countryId = message.hasOwnProperty('id') ? this.convertAlpha2Num(message.country[0].alpha2) : '';
        return Object.assign({}, { message, countryId });
    }

    render() {
        const { notifications, open, user } = this.props;
        const canReadNotifications = user.permissions.includes('notifications:READ');
        return (
            <ul className={'menu bk-notifications-menu ' + (open ? 'open' : '')}>
                <li className="bk-notifications-menu__header ">
                    <span>
                        Notifications
                        {canReadNotifications && (
                            <a
                                onClick={(e) => this.readAllNotifications(e)}
                                className="bk-notifications-menu__header__button">
                                Mark all as read
                            </a>
                        )}
                    </span>
                </li>
                <li>
                    <ul
                        className="bk-notifications-menu__list"
                        onScroll={(e) => {
                            const bottom = e.target.scrollHeight - e.target.scrollTop === e.target.clientHeight;
                            if (bottom) {
                                if (this.bottomTrigger) {
                                    this.bottomTrigger = false;
                                    this.loadMoreNotifications();
                                }
                            } else {
                                this.bottomTrigger = true;
                            }
                        }}>
                        {notifications.items.length === 0
                            ? !notifications.loader && (
                                  <li>
                                      <i>
                                          {notifications.status === constants.NotificationsStatusType.OK
                                              ? 'No notifications'
                                              : 'Unable to fetch notifications'}
                                      </i>
                                  </li>
                              )
                            : notifications.items.map((n, i) => {
                                  let licenceDetails;
                                  if (
                                      n.notification_type === 'LICENSE_REQUEST' &&
                                      n.licenseMeta.message_id &&
                                      Number(n.licenseMeta.message_id) > 0
                                  ) {
                                      licenceDetails = this.getLicenceDetails(n.licenseMeta.message_id);
                                  }
                                  return (
                                      <li
                                          key={`notification-${i}`}
                                          className={'menu__item--hoverable ' + (n.read ? '' : 'accent')}>
                                          <Link
                                              to={
                                                  n.notification_type === 'LICENSE_REQUEST' &&
                                                  n.licenseMeta.message_id &&
                                                  Number(n.licenseMeta.message_id) > 0
                                                      ? {
                                                            pathname: getWorkUrl(
                                                                licenceDetails.message.bk_work_id,
                                                                licenceDetails.countryId,
                                                            ),
                                                            state: {
                                                                requestLicenceModalOpen: true,
                                                                messageId: licenceDetails.message.id,
                                                                recipient: licenceDetails.message.recipient,
                                                                sender: licenceDetails.message.sender,
                                                            },
                                                        }
                                                      : n.href
                                              }
                                              onClick={(e) => this.readNotification(e, n.id, false)}>
                                              <span className="bk-notifications-menu__item">
                                                  {/*<span className="bk-notifications-menu__item-icon">
                                                                      <Icon icon="alert-circle" />
                                                        </span>*/}
                                                  <div className="bk-notifications-menu__item-avatar">
                                                      <DisplayPicture classNames={`notification`} user={n.sender} />
                                                  </div>
                                                  <span className="bk-notifications-menu__item-content">
                                                      {n.content}
                                                  </span>
                                              </span>
                                              <span className="bk-notifications-menu-time">{fromNow(n.createdAt)}</span>
                                              {!n.read && canReadNotifications && (
                                                  <span
                                                      className="bk-notifications-menu-action"
                                                      data-tooltip-id={`notification-item-${i}`}
                                                      onClick={(e) => this.readNotification(e, n.id, true)}>
                                                      <span>
                                                          <Icon icon="check" />
                                                      </span>
                                                  </span>
                                              )}
                                          </Link>
                                          <Tooltip className="tooltip" place="right" id={`notification-item-${i}`}>
                                              Mark as read
                                          </Tooltip>
                                      </li>
                                  );
                              })}
                        {notifications.loading && (
                            <li>
                                <LightLoader size="10px" color="#fafcfd" />
                            </li>
                        )}
                    </ul>
                </li>
            </ul>
        );
    }
}

const mapStateToProps = (state) => ({
    notifications: state.notifications,
    user: state.user,
    inbox: state.messages.inbox,
});

const mapDispatchToProps = (dispatch) => ({
    setAllNotificationsAsRead: () => dispatch(setAllNotificationsAsRead()),
    setNotificationAsRead: (notificationId) => dispatch(setNotificationAsRead(notificationId)),
    fetchNotifications: () => dispatch(fetchNotifications()),
    fetchInbox: () => dispatch(fetchInbox()),
});

NotificationsMenu.propTypes = {
    user: types.user.isRequired,
    history: types.history,
    open: PropTypes.bool,
    closeMenu: PropTypes.func,
    setNotificationAsRead: PropTypes.func,
    setAllNotificationsAsRead: PropTypes.func,
    fetchNotifications: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(NotificationsMenu));
